module.exports = __webpack_public_path__ + "img/AffiliateOperationTypes.1389c59e.svg";